import React from 'react';
import { Box } from 'rebass/styled-components';
import { Link } from '../components';

export default () => (
  <Box
    variant="basicPage"
    fontSize={2}
    p={4}
    mt={3}
    sx={{
      borderRadius: '30px',
      lineHeight: '1.4',
    }}
  >
    If you are seeing this your account does not have access to this feature yet.
    Please contact LivePerson to request access.
    {' '}
    <Link
      href="https://developers.liveperson.com/maven-overview.html"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more about Maven.
    </Link>
  </Box>
);
